import type { ReactNode } from 'react';
import React from 'react';
import type { FormatOptionLabelMeta } from 'react-select-modern';

import type { EDripTriggerAction } from '@feathr/blackbox';
import type { IUniversalSelectOption } from '@feathr/components';
import { Label } from '@feathr/components';

export interface ICustomSelectOption extends IUniversalSelectOption {
  id: EDripTriggerAction;
  description: string;
}

/* UniversalSelect calls this for both the menu rows and the selected value. */
export function formatTargetingOptionLabel(
  data: ICustomSelectOption,
  meta: FormatOptionLabelMeta<ICustomSelectOption>,
): ReactNode {
  if (meta.context === 'value') {
    return data.name;
  }

  return (
    <div>
      <Label margin={'condensed'} weight={'medium'}>
        {data.name}
      </Label>
      <p>{data.description}</p>
    </div>
  );
}
